import { useEffect, useState } from "react";
import classNames from "classnames";
import { Tab } from "components/molecules/Tab";
import { DropDown, Button, Typography } from "components/atoms";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH, TAB_WIDTH } from "utils/constants";
import { SelfPacedHomeworkTab } from "components/organisms/SelfPacedHomeworkTab";
import { SelfPacedTextOptionBtn } from "../SelfPacedTextOptionBtn";
import "./index.scss";

interface IProps {
  borderColor: string;
  isTabShow: boolean;
  groups?: any;
  groupNames?: any;
  styles?: string;
  title: string;
  timeSpan?: string;
  profileImage?: string;
  messageIcon?: boolean;
  btnLabel?: string;
  theme: "light" | "dark";
  itemPageNo?: number;
}

export const SelfPacedCourseworkDetailCard = ({
  borderColor = "black",
  isTabShow,
  title = "Test 4",
  groupNames,
  groups,
  theme,
  itemPageNo,
}: IProps) => {
  const [dropDownSelection, setDropDownSelection] = useState<
    null | string | { [key: number]: string }
  >("Diagnostic Exam");
  const [filterDropdownSelection, setFilterDropdownSelection] = useState<
    null | string | { [key: number]: string }
  >(null);
  const screen = useScreenSize();

  useEffect(()=> {
    setFilterDropdownSelection({ [0]: groupNames[0] });
  }, [])
  

  return (
    <div className="self-paced-coursework-tile-container">
      <div
        className={classNames(
          "self-paced-coursework-tile-wrapper",
          `self-paced-coursework-default-border-${borderColor}`
        )}
      >
        <div className="tile-container">
          <div className={classNames("content-section")}>
            <div className="content-1">
              <Typography
                label={title}
                variant={screen.width <= MOBILE_WIDTH ? "h7Bold" : "h5Bold"}
              />
            </div>
          </div>
          {isTabShow ? (
            screen.width <= MOBILE_WIDTH ? (
              <div className="self-paced-coursework-mobile-container">
                <div className="self-paced-coursework-mobile-drop-down-wrapper opk">
                  {groupNames && Array.isArray(groupNames) ? (
                    <DropDown
                      data={[...groupNames]}
                      styles="drop-down-custom-style"
                      setDropDownSelection={setFilterDropdownSelection}
                      defaultSelected={filterDropdownSelection}
                      placeholder="Select"
                    />
                  ) : null}
                </div>
                <div className="self-paced-coursework-mobile-tabs-contain-wrapper">
                  {(() => {
                    const selectedGroup = filterDropdownSelection && groups.find(
                      (group: any) =>
                        group.Name ===
                        Object.values(filterDropdownSelection)[0]
                    );
                    
                    if (!selectedGroup) return null;
                    
                    // Combine NonDrillSmartContent and DrillSmartGrouping items
                    let contentToShow: any[] = [];
                    
                    // Add NonDrillSmartContent items
                    if (selectedGroup.NonDrillSmartContent?.Content) {
                      contentToShow = [...selectedGroup.NonDrillSmartContent.Content];
                    }
                    
                    // Add each DrillSmartGrouping as a single item (not the individual Content within it)
                    if (selectedGroup.DrillSmartGrouping && Array.isArray(selectedGroup.DrillSmartGrouping)) {
                      selectedGroup.DrillSmartGrouping.forEach((drillGroup: any) => {
                        // Add the entire DrillSmartGrouping object, marked so it can be identified
                        contentToShow.push({
                          ...drillGroup,
                          _isDrillSmartGrouping: true
                        });
                      });
                    }
                    
                    return (
                      <SelfPacedTextOptionBtn
                        isMobile={screen.width <= MOBILE_WIDTH}
                        exams={contentToShow}
                        theme={theme}
                        type={filterDropdownSelection}
                      />
                    );
                  })()}
                </div>
              </div>
            ) : (
              <div className="tab-section">
                {groupNames && Array.isArray(groupNames) && groups && Array.isArray(groups) ? (
                  <Tab
                    tabTitles={groupNames.map((group: string, index: number) => (
                      <p
                        key={index}
                        id={`self-paced-${group.toLowerCase().replace(/\s+/g, '-')}-tab`}
                      >
                        {group}
                      </p>
                    ))}
                    tabContents={groups.map((group: any, index: number) => {
                      // Combine NonDrillSmartContent and DrillSmartGrouping items into a single list
                      let combinedContent: any[] = [];
                      
                      // Add NonDrillSmartContent items
                      if (group.NonDrillSmartContent?.Content && Array.isArray(group.NonDrillSmartContent.Content)) {
                        combinedContent = [...group.NonDrillSmartContent.Content];
                      }
                      
                      // Add each DrillSmartGrouping as a single item (not the individual Content within it)
                      if (group.DrillSmartGrouping && Array.isArray(group.DrillSmartGrouping)) {
                        group.DrillSmartGrouping.forEach((drillGroup: any) => {
                          // Add the entire DrillSmartGrouping object, marked so it can be identified
                          combinedContent.push({
                            ...drillGroup,
                            _isDrillSmartGrouping: true
                          });
                        });
                      }
                      
                      // Only render tab if there's content
                      if (combinedContent.length > 0) {
                        return (
                          <SelfPacedHomeworkTab
                            key={index}
                            exams={combinedContent}
                            type="MixedContent"
                            theme={theme}
                            itemPageNo={itemPageNo}
                          />
                        );
                      }
                      
                      return null;
                    })}
                    defaultActiveTab={0}
                  />
                ) : null}
              </div>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};
